var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mx-element',{attrs:{"type":"ColumnFrame","theme":"None"}},[_vm._l((_vm.columns),function(item,index){return _c('div',{key:index},[_vm._t("default",null,{"config":item,"index":index})],2)}),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }